import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevopsComponent } from './devops/devops.component';
import { BespokeComponent } from './bespoke/bespoke.component';
import { QualityAssuaranceComponent } from './quality-assuarance/quality-assuarance.component';
import { SoftwareDevelopmentComponent } from './software-development/software-development.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [DevopsComponent, BespokeComponent, QualityAssuaranceComponent, SoftwareDevelopmentComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class SoftwareDevelopmentModule { }
